/* import __COLOCATED_TEMPLATE__ from './error.hbs'; */
import Component from '@glimmer/component';
import {
  getMaxTempRange,
  addChartFn,
  getVoltRefErrors,
  tryParseFloat,
  addDetailsForErrorCategory,
  notAvailable,
} from '../../utils/error-utils';
import { service } from '@ember/service';
import { action } from '@ember/object';
import Constants from '../../utils/constants';

const PARAM = Constants.CDP.PARAMETERS;

export default class Error extends Component {
  @service intl;

  @action getErrorData() {
    const findInTopologies = (name) => this.args.model.topologyInputHandler.current.find((t) => t.config.name === name); // switch to ID in future
    const findInResistors = (id) => this.args.model.resistorHandler.currentResistors.find((t) => t.id === id);

    const dacSelected = this.args.model.signalChainHandler.dac.selected,
      currentSignalChain = this.args.model.signalChainHandler.currentItems;

    // const vref = findInTopologies('voltage-reference');
    const outType = findInTopologies('iout-or-vout'),
      rset = findInTopologies('rset'),
      rsetResistor = findInResistors(Constants.RESISTORS.EXTERNAL_RSET),
      voltRef = currentSignalChain.find((item) => item.isVoltageReference),
      voltRefErrors = getVoltRefErrors(voltRef.selected, dacSelected, this.args.model);

    // DAC
    let dacErrors = []; // calculated differently than most DACs
    const addDacDetails = addDetailsForErrorCategory(dacErrors, this.args.model);
    // TUE Iout Error / TUE Vout Error
    if (outType.selectedOption.id == Constants.TOPOLOGY_OPTIONS.IOUT) {
      console.log('iOut');
      let errorMessage;
      let tueIout;
      if (rset.isSelectedOptionExternal) {
        tueIout = tryParseFloat(dacSelected, PARAM.TUE_IOUT_EXTERNAL_RSET); // TUE Iout (External Rset)
        errorMessage = notAvailable(['tue_iout_ext_rset']);
        console.log('external rset');
      } else {
        tueIout = tryParseFloat(dacSelected, PARAM.TUE_IOUT_INTERNAL_RSET); // TUE Iout (Internal Rset)
        errorMessage = notAvailable(['tue_iout_int_rset']);
        console.log('internal rset');
      }

      addDacDetails(
        'tue_iout',
        [tueIout],
        tueIout * 10000,
        errorMessage,
        true, // show help topic
      );
    } else {
      console.log('vOut');
      let errorMessage;
      // if(rset.isSelectedOptionExternal) {
      //     console.log('external rset');
      // } else {
      //     console.log('internal rset');
      // }
      errorMessage = notAvailable(['tue_vout']);
      addDacDetails(
        'tue_vout',
        false, // always errors out
        0,
        errorMessage,
        false, // show help topic
      );
    }

    // Resistor / Rset errors
    let rsetErrors = [];
    const addRsetDetails = addDetailsForErrorCategory(rsetErrors, this.args.model);
    if (rset.isSelectedOptionExternal) {
      // TODO: Get this from resistor
      const rsetTolerance = rsetResistor.tolerance;
      const rsetTempco = rsetResistor.tempco;
      const maxTempRange = getMaxTempRange(this.args.model);
      addRsetDetails(
        'rset_tolerance',
        [rsetTolerance],
        rsetTolerance * 10000,
        notAvailable(['rset_tolerance']),
        true, // show help topic
      );

      addRsetDetails(
        'rset_tempco',
        [rsetTempco],
        rsetTempco * maxTempRange,
        notAvailable(['rset_tempco']),
        true, // show help topic
      );
    }

    let chartInfo = { charts: [] }; // Array of all charts
    const addChart = addChartFn(chartInfo.charts);
    addChart(this.intl.t('labels.parts.voltage_reference'), Constants.SVG_PARTS.voltage_reference, voltRefErrors);
    addChart(this.intl.t('labels.parts.current_source_dac'), Constants.SVG_PARTS.current_source_dac, dacErrors);
    addChart(this.intl.t('labels.parts.external_rset'), Constants.SVG_PARTS.external_rset, rsetErrors);
    return chartInfo;
  }
}
